import { useEffect } from 'react'

export const useAutosizeTextArea = (
  textAreaRef: HTMLTextAreaElement | null,
  value: string
) => {
  useEffect(() => {
    if (textAreaRef) {
      textAreaRef.style.height = 'inherit'
      const { scrollHeight } = textAreaRef

      textAreaRef.style.height = `${scrollHeight}px`
    }
  }, [textAreaRef, value])
}
